function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries;
  return {
    base: _defineProperty({
      padding: '15px',
      textAlign: 'center',
      fontSize: '14px',
      color: colors.white,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }, mediaQueries.breakpointTablet, {
      fontSize: '13px'
    }),
    icon: _defineProperty({
      fill: colors.white,
      width: '18px',
      height: '16px',
      marginRight: '12px',
      display: 'inline-block'
    }, mediaQueries.breakpointTablet, {
      marginRight: '6px'
    }),
    centerIcon: {
      marginLeft: 'auto'
    },
    closeIcon: {
      fill: colors.white,
      width: '18px',
      height: '16px',
      cursor: 'pointer',
      display: 'inline-block',
      marginLeft: 'auto'
    },
    message: _defineProperty({}, mediaQueries.breakpointTablet, {
      textAlign: 'left'
    }),
    warning: {
      backgroundColor: colors.warning
    },
    error: {
      backgroundColor: colors.error
    },
    info: {
      backgroundColor: colors.primary
    },
    neutral: {
      backgroundColor: colors.neutral,
      '& $message': {
        color: '#46484B'
      },
      '& $icon': {
        fill: '#46484B'
      }
    }
  };
});